import React from 'react';
import {observable, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import PaymentCodes from '../payment/paymentCodes';
import ModalSimple from '../../../global/modal-simple';

interface IPaymentCodesProps {
    reloadPayment: () => void;
    reloadPaymentFailure: () => void;
    modalId: string;
}

@observer
class ModalInfo extends React.Component<IPaymentCodesProps> {
    @observable gradYear: string;

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    render() {
        return (
            <ModalSimple
                id={this.props.modalId}
                title={'Promo Codes and Gift Cards'}
            >
                <div className="modal-body text-left">
                    <PaymentCodes
                        reloadPayment={this.props.reloadPayment}
                        reloadPaymentFailure={this.props.reloadPaymentFailure}
                        promoOnly={false}
                    />
                </div>
            </ModalSimple>
        );
    }
}
export default ModalInfo;
